import React from "react";
import { useRef } from "react";
import { Text } from '@shopify/polaris';

export function hasLength(params: any = []) {
    return params && Object.keys(params)?.length > 0;
}

export const scope = {
    hasLength: function (params: any = []) {
        return params && Object.keys(params)?.length > 0;
    },
    dataTypeLength: function (params: any = []) {
        return params && Object.keys(params)?.length;
    }
}

export default function useDynamicRefs() {
    const refs: any = {
        title: useRef(null),
        description: useRef(null),
        category_settings: useRef(null)
    }

    function getRef(type: string) {
        return refs[type];
    }

    return { getRef }
}

export function outdatedAppMessage() {
    return (
        <div className="announcement-bar" style={{
            position: 'fixed',
            top: 0,
            zIndex: '99',
            paddingBottom: '10px',
            left: '0',
            overflow: 'hidden',
            width: '100%'
        }}>
            <img style={{ width: '100%' }} src={'https://amazon.demo.sellernext.com/multi-account/apps/assests/webinar_top_strip.png'} />
            <Text as="p">
                Due to the national holiday on account of Republic Day celebration in India, Kindly excuse us for limited support on 26th January 2023. Raise your queries at <a href="javascript:void(0)" >support@cedcommerce.com</a>
            </Text>

        </div >
    )
}